import type { ShareServiceConfig } from "../../../shared/index.js";

export const qq: ShareServiceConfig = {
  link: 'https://connect.qq.com/widget/shareqq/index.html?url=[url]&title=[title]&source=[title]&desc=[description]&pics=[cover]&summary="[summary]"',
  color: "#5eaade",
  shape:
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path d="M863 626c-17-58-38-107-70-186 5-209-82-378-281-378-202 0-286 172-281 378-32 80-52 128-70 186-39 123-26 174-17 175 20 3 79-93 79-93 0 56 28 127 89 179-29 9-96 34-80 61 13 21 220 14 280 7 60 7 267 14 280-7 16-27-51-52-80-61 61-52 89-124 89-179 0 0 59 96 79 93 9-1 22-52-17-175"/></svg>',
};
